webpackJsonp([1],{

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_files_android_logo_svg__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_files_android_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_svg_files_android_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_files_color_circles_svg__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_files_color_circles_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_svg_files_color_circles_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_files_debian_logo_svg__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_files_debian_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_svg_files_debian_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_files_eff_logo_svg__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_files_eff_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_svg_files_eff_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_files_heart_svg__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_files_heart_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_svg_files_heart_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_svg_files_mozilla_logo_svg__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_svg_files_mozilla_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_svg_files_mozilla_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_svg_files_rss_logo_svg__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_svg_files_rss_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_svg_files_rss_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_svg_files_utensils_svg__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_svg_files_utensils_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_svg_files_utensils_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_svg_files_warning_sign_svg__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_svg_files_warning_sign_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_svg_files_warning_sign_svg__);













__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */].Store({
  state: {
    mode: 'd3',
    chosenImage: 'android-logo',
    availableImages: {
      'android-logo': __WEBPACK_IMPORTED_MODULE_3__assets_svg_files_android_logo_svg___default.a,
      'color-circles': __WEBPACK_IMPORTED_MODULE_4__assets_svg_files_color_circles_svg___default.a,
      'debian-logo': __WEBPACK_IMPORTED_MODULE_5__assets_svg_files_debian_logo_svg___default.a,
      'eff-logo': __WEBPACK_IMPORTED_MODULE_6__assets_svg_files_eff_logo_svg___default.a,
      heart: __WEBPACK_IMPORTED_MODULE_7__assets_svg_files_heart_svg___default.a,
      'mozilla-logo': __WEBPACK_IMPORTED_MODULE_8__assets_svg_files_mozilla_logo_svg___default.a,
      'rss-logo': __WEBPACK_IMPORTED_MODULE_9__assets_svg_files_rss_logo_svg___default.a,
      utensils: __WEBPACK_IMPORTED_MODULE_10__assets_svg_files_utensils_svg___default.a,
      'warning-sign': __WEBPACK_IMPORTED_MODULE_11__assets_svg_files_warning_sign_svg___default.a
    },
    availableModes: ['d3', 'pixi']
  },
  getters: {
    retrieveImage: function retrieveImage(state) {
      return state.availableImages[state.chosenImage];
    },
    retrieveImageList: function retrieveImageList(state) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.availableImages);
    },
    retrieveModeList: function retrieveModeList(state) {
      return state.availableModes;
    }
  },
  mutations: {
    CHOOSE_MODE: function CHOOSE_MODE(state, payload) {
      state.mode = payload;
    },
    CHOOSE_IMAGE: function CHOOSE_IMAGE(state, payload) {
      state.chosenImage = payload;
    }
  },
  actions: {
    CHOOSE_MODE: function CHOOSE_MODE(_ref, data) {
      var commit = _ref.commit;

      commit('CHOOSE_MODE', data);
    },
    CHOOSE_IMAGE: function CHOOSE_IMAGE(_ref2, data) {
      var commit = _ref2.commit;

      commit('CHOOSE_IMAGE', data);
    }
  }
}));

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(57)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(279),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(119);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SvgCompare__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SvgCompare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SvgCompare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_D3Compare__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_D3Compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_D3Compare__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'svg-compare': __WEBPACK_IMPORTED_MODULE_2__components_SvgCompare___default.a,
    'd3-compare': __WEBPACK_IMPORTED_MODULE_3__components_D3Compare___default.a
  },
  created: function created() {
    this.selectedMode = this.$store.state.mode;
    this.selectedImage = this.$store.state.chosenImage;
  },
  data: function data() {
    return {
      selectedMode: null,
      selectedImage: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    imageList: 'retrieveImageList',
    modeList: 'retrieveModeList'
  })),
  watch: {
    selectedMode: function selectedMode(newVal) {
      this.$store.dispatch('CHOOSE_MODE', newVal);
    },
    selectedImage: function selectedImage(newVal) {
      this.$store.dispatch('CHOOSE_IMAGE', newVal);
    }
  }
});

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);

//
//
//
//
//
//

/* global d3 */
// import * as d3 from 'd3'
// import { event as currentEvent } from 'd3-selection'
// import * as d3Random from 'd3-random'
// import * as d3Scale from 'd3-scale'

// import androidImage from '../assets/svg-files/android-logo.svg'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'svg-compare',
  data: function data() {
    return {
      width: 800,
      height: 600
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    chosenImage: 'retrieveImage'
  })),
  watch: {
    chosenImage: function chosenImage(newVal) {
      this.reset();
      this.init();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.reset();
  },

  methods: {
    reset: function reset() {
      d3.select('#svgEmbed').selectAll('svg').remove();
    },
    init: function init() {
      var svg = d3.select('#svgEmbed').append('svg').attr('width', this.width).attr('height', this.height).append('g').call(d3.behavior.zoom().scaleExtent([1, 8]).on('zoom', zoom)).append('g');

      svg.append('rect').attr('class', 'overlay').attr('width', this.width).attr('height', this.height);

      svg.append('image').datum(this.chosenImage).attr('height', this.height).attr('width', this.width).attr('xlink:href', function (d) {
        return d;
      });

      function zoom() {
        svg.attr('transform', 'translate(' + d3.event.translate + ')scale(' + d3.event.scale + ')');
      }
    },
    testD3: function testD3() {
      var width = 960;
      var height = 500;

      var randomX = d3.random.normal(width / 2, 80);
      var randomY = d3.random.normal(height / 2, 80);

      var data = d3.range(2000).map(function () {
        return [randomX(), randomY()];
      });

      var svg = d3.select('body').append('svg').attr('width', width).attr('height', height).append('g').call(d3.behavior.zoom().scaleExtent([1, 8]).on('zoom', zoom)).append('g');

      svg.append('rect').attr('class', 'overlay').attr('width', width).attr('height', height);

      svg.selectAll('circle').data(data).enter().append('circle').attr('r', 2.5).attr('transform', function (d) {
        return 'translate(' + d + ')';
      });

      function zoom() {
        svg.attr('transform', 'translate(' + d3.event.translate + ')scale(' + d3.event.scale + ')');
      }
    }
  }
});

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pixi_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(31);


//
//
//
//
//
//
//
//
//
//
//
//
//



// const androidImage = require('../assets/svg-files/android-logo.svg')

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'svg-compare',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      renderer: null,
      container: null,
      stage: null,
      bunny: null,
      androidLogo: null,
      selectedScale: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    chosenImage: 'retrieveImage'
  })),
  watch: {
    selectedScale: function selectedScale(newVal) {
      if (this.androidLogo) {
        this.androidLogo.scale.x = newVal;
        this.androidLogo.scale.y = newVal;
      }
    },
    chosenImage: function chosenImage(newVal) {
      this.reset();
      this.initSvgCanvas();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.initSvgCanvas();
  },
  beforeDestroy: function beforeDestroy() {
    this.reset();
  },

  methods: {
    reset: function reset() {
      this.container.destroy();
      this.renderer.destroy();

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.getElementsByTagName('canvas')).forEach(function (el) {
        el.parentElement.removeChild(el);
      });
    },
    animate: function animate() {
      requestAnimationFrame(this.animate);
      this.bunny.rotation += 0.1;

      // render the container
      this.renderer.render(this.stage);
    },
    initSvgCanvas: function initSvgCanvas() {
      console.log(__WEBPACK_IMPORTED_MODULE_2_pixi_js__);
      this.renderer = new __WEBPACK_IMPORTED_MODULE_2_pixi_js__["Application"](800, 600, { backgroundColor: 0x1099bb });
      document.getElementById('svg-canvas').innerHTML = '';
      // document.getElementById('svg-canvas').appendChild(this.renderer.view)
      document.getElementById('svg-canvas').appendChild(this.renderer.view);
      this.container = new __WEBPACK_IMPORTED_MODULE_2_pixi_js__["Container"]();
      this.stage = this.renderer.stage;
      this.stage.addChild(this.container);

      var serializedSvg = '<?xml version="1.0" encoding="UTF-8" standalone="no"?> <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" width="31.818079" height="45.147041" viewBox="0 0 31.818079 45.147041" id="svg2" version="1.1"> <defs id="defs4" /> <metadata id="metadata7"> <rdf:RDF> <cc:Work rdf:about=""> <dc:format>image/svg+xml</dc:format> <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" /> <dc:title></dc:title> </cc:Work> </rdf:RDF> </metadata> <g transform="translate(-0.12926931,-988.46553)" id="layer1"> <path style="opacity:1;fill:#ba8500;fill-opacity:1;stroke:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m 10.751928,988.59808 c -1.9694019,-0.0197 -3.6372455,0.99804 -3.6372455,2.62011 l 0,13.85491 c 4.384e-4,0.481 -0.3896616,0.8712 -0.8707394,0.8707 l -3.9038968,0 c -0.9033766,0 -1.60196836,0.6999 -1.60196836,1.6043 0,0.9044 0.69762626,1.602 1.60196836,1.602 l 3.9038968,0 c 0.4810778,-3e-4 0.8711778,0.3897 0.8707394,0.8707 l 0,20.0126 c 0,0.8302 0.1769703,1.4944 0.4498028,1.8834 0.2728312,0.3892 0.591211,0.5966 1.3109201,0.5966 0.7702837,0 1.0303352,-0.1949 1.2748396,-0.5869 0.244504,-0.3921 0.392074,-1.1044 0.392073,-1.9845 l 0,-1.7222 c 0,-1.5022 1.237448,-1.6951 2.739704,-1.6951 l 5.828183,0 c 1.502255,0 2.739703,0.1929 2.739703,1.6951 l 0,2.0157 c 0,0.8205 0.140867,1.4376 0.355993,1.7583 0.215126,0.3208 0.463055,0.5004 1.23876,0.5004 0.722664,0 1.02629,-0.2014 1.289272,-0.5822 0.262981,-0.3807 0.432964,-1.0425 0.432964,-1.8786 l 0,-20.0126 c -4.38e-4,-0.481 0.389662,-0.871 0.87074,-0.8707 l 3.682603,0 c 0.904342,0 1.604374,-0.6986 1.604374,-1.602 0,-0.9033 -0.700997,-1.6043 -1.604374,-1.6043 l -3.682603,0 c -0.481078,5e-4 -0.871178,-0.3897 -0.87074,-0.8707 l 0,-13.85491 c 0,-1.33758 -1.115978,-2.52048 -3.141742,-2.59264 -1.745732,-0.0628 -3.597139,0.93732 -3.597139,2.54584 l 0,2.77618 c 0,1.04706 -0.862488,1.48796 -1.909541,1.48796 l -0.536483,0 c -1.047053,0 -1.90954,-0.4409 -1.90954,-1.48796 l 0,-2.68073 c 0,-1.64362 -1.367284,-2.64905 -3.320524,-2.66876 z" id="path4195" /> <path style="opacity:1;fill:#efaf14;fill-opacity:1;stroke:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m 10.836553,989.15819 c -1.3307328,-0.0136 -2.5099529,0.45764 -3.1438037,1.25802 0.5004057,-0.0776 0.9727445,-0.13707 1.3470007,-0.13707 2.021576,0 3.421262,0.0776 3.576768,1.24361 0.155505,1.1664 -0.155201,5.44248 1.166599,5.28693 0.833868,-0.0985 2.006652,-0.35173 2.857565,-0.81774 -0.01355,1.2e-4 -0.02487,0 -0.03849,0 l -0.536394,0 c -1.047054,0 -1.90745,-0.44176 -1.90745,-1.48894 l 0,-2.67963 c 0,-1.64362 -1.368559,-2.65028 -3.321799,-2.66998 z m 11.273915,0.0296 c -1.428208,-0.0517 -2.91037,0.61651 -3.408394,1.73906 1.757099,-0.43006 3.973415,-0.67181 4.567776,0.44261 0.622023,1.16628 -7.76e-4,6.60801 0.07697,8.47405 0.07775,1.86609 -1.009884,5.67629 0.389668,6.92029 1.399553,1.2441 3.187527,1.5537 4.820338,1.3204 0.817371,-0.117 1.905479,0.101 2.770973,0.5196 0.04883,-0.1559 0.08179,-0.3182 0.08179,-0.4931 0,-0.9033 -0.700998,-1.6043 -1.604374,-1.6043 l -3.682604,0 c -0.481078,5e-4 -0.871177,-0.3897 -0.870739,-0.8707 l 0,-13.8549 c 0,-1.33758 -1.115635,-2.52085 -3.141403,-2.59301 z" id="path4195-5" /> <path style="opacity:1;fill:#875f00;fill-opacity:1;stroke:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m 2.2687276,1005.9607 c -0.9033766,0 -1.60196835,0.6999 -1.60196835,1.6043 0,0.9043 0.69762625,1.602 1.60196835,1.602 l 3.9038968,0 c 0.4810778,-4e-4 0.8711778,0.3897 0.8707394,0.8707 l 0,20.0126 c 0,0.8302 0.1769703,1.4943 0.4498028,1.8834 0.2728312,0.3892 0.591211,0.5965 1.3109201,0.5965 0.7702837,0 1.0303339,-0.1949 1.2748383,-0.5869 0.244504,-0.3921 0.392075,-1.1043 0.392074,-1.9844 l 0,-1.7222 c 0,-1.5022 1.237448,-1.6958 2.739703,-1.6958 l 5.828183,0 c 1.502255,0 2.739703,0.1936 2.739703,1.6958 l 0,2.0157 c 0,0.8204 0.140868,1.4376 0.355994,1.7583 0.215126,0.3208 0.463054,0.5003 1.238759,0.5003 0.722664,0 1.02629,-0.2013 1.289272,-0.5821 0.262981,-0.3807 0.432965,-1.0425 0.432965,-1.8786 l 0,-1.5658 c -0.01145,-0.012 -0.02741,-0.019 -0.03849,-0.03 -1.710565,-1.555 -2.409217,-3.4206 -4.89731,-4.1203 -2.488094,-0.6998 -4.82179,-0.6212 -7.309884,0.1564 -2.488092,0.7774 -1.942992,3.186 -2.9537795,2.3307 -1.0107881,-0.8553 -0.2325437,-6.4517 -0.3102911,-8.551 -0.077747,-2.0993 0.7764426,-8.0089 -1.0896265,-10.2637 -0.9902484,-1.1966 -1.9585532,-1.7628 -2.6699481,-2.0469 z" id="path4195-9" /> <path style="opacity:1;fill:none;fill-opacity:1;stroke:#000000;stroke-width:1.23154354;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m 10.758891,989.08159 c -1.9694017,-0.0197 -3.6372454,0.99804 -3.6372454,2.6201 l 0,13.85481 c 4.385e-4,0.481 -0.3896616,0.8712 -0.8707394,0.8707 l -3.9038968,0 c -0.9033766,0 -1.60196832,0.6999 -1.60196832,1.6043 0,0.9043 0.69762622,1.602 1.60196832,1.602 l 3.9038968,0 c 0.4810778,-4e-4 0.8711779,0.3897 0.8707394,0.8707 l 0,20.0126 c 0,0.8302 0.1769704,1.4943 0.4498028,1.8834 0.2728312,0.3892 0.5912111,0.5966 1.3109202,0.5966 0.7702836,0 1.0303351,-0.1949 1.2748394,-0.5869 0.244504,-0.3921 0.392074,-1.1044 0.392073,-1.9845 l 0,-1.7222 c 0,-1.5022 1.237449,-1.6951 2.739704,-1.6951 l 5.828183,0 c 1.502255,0 2.739703,0.1929 2.739703,1.6951 l 0,2.0157 c 0,0.8204 0.140868,1.4376 0.355994,1.7583 0.215126,0.3208 0.463054,0.5003 1.238759,0.5003 0.722665,0 1.02629,-0.2013 1.289272,-0.5821 0.262981,-0.3807 0.432964,-1.0425 0.432964,-1.8786 l 0,-20.0126 c -4.38e-4,-0.481 0.389663,-0.8711 0.87074,-0.8707 l 3.682604,0 c 0.904342,0 1.604373,-0.6986 1.604373,-1.602 0,-0.9033 -0.700997,-1.6043 -1.604373,-1.6043 l -3.682604,0 c -0.481077,5e-4 -0.871178,-0.3897 -0.87074,-0.8707 l 0,-13.85481 c 0,-1.33757 -1.115978,-2.52047 -3.141742,-2.59264 -1.745732,-0.0628 -3.597139,0.93733 -3.597139,2.54585 l 0,2.77618 c 0,1.04706 -0.862488,1.48795 -1.909541,1.48795 l -0.536483,0 c -1.047053,0 -1.90954,-0.44089 -1.90954,-1.48795 l 0,-2.68074 c 0,-1.64362 -1.367284,-2.64905 -3.320524,-2.66875 z" id="path4195-8" /> <rect style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:#efaf14;stroke-width:1.23154354;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" id="rect4233" width="9.9523754" height="11.196422" x="11.373137" y="1011.0392" rx="2.9056232" ry="2.9056232" /> <path style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:#efaf14;stroke-width:0.84114426;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m 9.8782858,990.70587 1.5124012,0 c 0.78773,0 1.421895,0.63412 1.421895,1.42182 l 0,2.83431 c 0,1.71665 -0.862234,1.81665 -2.216977,3.17134 -1.1207889,-1.1207 -2.1392138,-1.17095 -2.1392138,-3.17134 l 0,-2.83431 c 0,-0.7877 0.6341649,-1.42182 1.4218946,-1.42182 z" id="rect4233-3" /> <path style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:#efaf14;stroke-width:0.84114426;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m 21.191331,990.84171 1.512402,0 c 0.78773,0 1.421895,0.63412 1.421895,1.42181 l 0,2.83432 c 0,1.71664 -0.862235,1.81665 -2.216977,3.17134 -1.120789,-1.1207 -2.139214,-1.17095 -2.139214,-3.17134 l 0,-2.83432 c 0,-0.78769 0.634165,-1.42181 1.421894,-1.42181 z" id="rect4233-3-6" /> <rect style="opacity:1;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.58027852;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" id="rect4286" width="1.8818077" height="3.1305709" x="19.513754" y="1001.2766" rx="0.76223016" ry="0.76223016" /> <rect style="opacity:1;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.58027852;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" id="rect4286-9" width="1.8818077" height="3.1305709" x="10.767316" y="1001.3204" rx="0.76223016" ry="0.76223016" /> <rect style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:0.58027852;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" id="rect4286-9-1-6" width="3.2757361" height="3.2172124" x="14.392793" y="1005.8312" rx="0.5317775" ry="0.5317775" /> <rect style="opacity:1;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.58027852;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" id="rect4286-9-1" width="5.8047986" height="1.6777828" x="13.275428" y="1004.8306" rx="0.80775315" ry="0.80775315" /> </g> </svg>';

      var texture = __WEBPACK_IMPORTED_MODULE_2_pixi_js__["Texture"].fromImage('data:image/svg+xml;charset=utf8,' + serializedSvg);
      this.bunny = new __WEBPACK_IMPORTED_MODULE_2_pixi_js__["Sprite"](texture);

      var shit = __WEBPACK_IMPORTED_MODULE_2_pixi_js__["Texture"].fromImage(this.chosenImage);
      // ./assets/logo.png
      this.androidLogo = new __WEBPACK_IMPORTED_MODULE_2_pixi_js__["Sprite"](shit);

      this.bunny.anchor.x = 0.5;
      this.bunny.anchor.y = 0.5;

      this.bunny.position.x = 400;
      this.bunny.position.y = 300;

      this.androidLogo.anchor.x = 0.8;
      this.androidLogo.anchor.y = 0.8;

      this.androidLogo.position.x = 400;
      this.androidLogo.position.y = 300;

      this.androidLogo.scale.x = this.selectedScale;
      this.androidLogo.scale.y = this.selectedScale;

      this.container.addChild(this.bunny);
      this.container.addChild(this.androidLogo);
      // this.renderer.render(this.stage)
      // this.animate()
    }
  }
});

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDk2IDEwNSIgd2lkdGg9Ijk2IiBoZWlnaHQ9IjEwNSI+CiAgPGcgZmlsbD0iIzk3QzAyNCIgc3Ryb2tlPSIjOTdDMDI0IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbGluZWNhcD0icm91bmQiPgogICAgPHBhdGggZD0iTTE0LDQwdjI0TTgxLDQwdjI0TTM4LDY4djI0TTU3LDY4djI0TTI4LDQydjMxaDM5di0zMXoiIHN0cm9rZS13aWR0aD0iMTIiLz4KICAgIDxwYXRoIGQ9Ik0zMiw1bDUsMTBNNjQsNWwtNiwxMCAiIHN0cm9rZS13aWR0aD0iMiIvPgogIDwvZz4KICA8cGF0aCBkPSJNMjIsMzVoNTF2MTBoLTUxek0yMiwzM2MwLTMxLDUxLTMxLDUxLDAiIGZpbGw9IiM5N0MwMjQiLz4KICA8ZyBmaWxsPSIjRkZGIj4KICAgIDxjaXJjbGUgY3g9IjM2IiBjeT0iMjIiIHI9IjIiLz4KICAgIDxjaXJjbGUgY3g9IjU5IiBjeT0iMjIiIHI9IjIiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIGlkPSdzdmcxJyB2aWV3Qm94PScwIDAgMTAwIDEwMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+CiAgPGNpcmNsZSByPSIzMiIgY3g9IjM1IiBjeT0iNjUiIGZpbGw9IiNGMDAiIG9wYWNpdHk9IjAuNSIvPgogIDxjaXJjbGUgcj0iMzIiIGN4PSI2NSIgY3k9IjY1IiBmaWxsPSIjMEYwIiBvcGFjaXR5PSIwLjUiLz4KICA8Y2lyY2xlIHI9IjMyIiBjeD0iNTAiIGN5PSIzNSIgZmlsbD0iIzAwRiIgb3BhY2l0eT0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZpZXdCb3g9JzAgMCAxMDAgMTAwJyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj4KICA8cGF0aCBkPSdNNTksNTJjLTIsMCwwLDEsMiwxbDItMWgtNE02Nyw1MGwyLTRsLTEsM2MtMywyLDAtMSwwLTJjLTMsNC0xLDItMSwzTTcwLDQyYzEtMywwLTIsMC0xdjFNNTMsM2wyLDFjMSwwLDEtMS0yLTFNNTUsNGgtMXpNODEsNDNjMCwzLTEsNC0yLDZsLTEsMWwtMSwzbC02LDVjLTEsMCwwLTEsMS0xYy0zLDEtMiwyLTYsM2MtOSw0LTIxLTQtMjEtMTVjLTEtNSwyLTExLDgtMTNjNS0zLDExLTIsMTQsMWMtMi0yLTYtNS0xMC01Yy01LDAtOSwzLTExLDdjLTIsMS0yLDUtMyw2Yy0yLDEwLDIsMTUsOSwyMGMxLDEsMCwxLDAsMWwtNi00bDQsM2MtMywwLTUtNS02LTVjMyw3LDE1LDEyLDIxLDljLTMsMC03LDAtMTAtMWMtMS0xLTMtMi0yLTJjOCwzLDE2LDIsMjMtNGw0LTNjLTEsMSwwLDAsMCwxYzEtMi0xLTEsMS00bDEsMWMwLTMsMy01LDMtOWMxLTEsMSwxLDAsNGMxLTMsMC00LDEtNmMwLDEsMCwyLDEsMmMtMS0yLDAtNCwxLTZjLTEsMC0xLDEtMi0yYzAtMSwxLTEsMS0xbC0yLTNjMS0xLDEsMSwyLDFsLTEtNGMtMS0zLTEsMC0yLTJjLTEtNCwyLTEsMi0zbDQsMTBsLTItN2MwLDEtMS01LDEtMWMtMi04LTktMTQtMTUtMThjMSwxLDIsMiwxLDJjLTMtMi0yLTItMy0zYy0yLTEtMiwxLTQsMGMtNC0yLTUtMi05LTN2MWMtMy0xLTQsMC03LDBjMC0xLDEtMSwyLTFjLTMsMC0zLTEtNiwwbDMtMWMtMywwLTYsMS01LDBjLTQsMi0xMSw0LTE1LDh2LTFjLTIsMi04LDYtOCw5aC0xYy0xLDItMSw0LTIsNWMtMSwyLTIsMS0yLDFsLTQsMTNjMSwxLDAsNiwwLDExYy0xLDIxLDE1LDQyLDMzLDQ3YzMsMSw3LDEsMTAsMWwtOC0yYy0zLTEtMy0zLTUtNHYxYy0zLTEtMi0yLTUtM2wxLTFjLTEsMC0zLTItNC0zaC0xbC0zLTRjLTEtMS02LTctMy02Yy0xLDAtMiwwLTItMmwtMi01YzAsMSwxLDEsMiwxYy00LTktNCwwLTctOWgxYy0xLDAtMS0xLTEtMnYtMmMtMy0zLTEtMTIsMC0xOGMwLTIsMi00LDMtN2gtMWMyLTMsMTAtMTIsMTMtMTFjMi0zLDAsMC0xLTFjNC00LDUtMyw4LTNjMy0yLTIsMC0xLTFjNS0xLDMtMyw5LTNjMSwwLTEsMC0yLDFjNC0yLDEzLTIsMTgsMWM3LDMsMTQsMTIsMTQsMjBoMWMwLDMsMCw3LTEsMTF6TTQyLDU0djJsMyw0bC0zLTZNNDQsNTRsLTEtMmMwLDIsMSwzLDIsNHpNODcsNDV2MWMwLDMtMSw1LTMsOGMyLTMsMy02LDMtOU01MywzYzEtMSwzLTEsNC0xaC00ek0xNiwyMmMwLDMtMiw0LDAsMmMyLTMsMC0xLDAtMk0xMywzM2wxLTNjLTEsMSwwLDItMSwzJyBmaWxsPScjRDcwNzUxJy8+Cjwvc3ZnPgo="

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiPgogIDxjaXJjbGUgY3g9Ijc4IiBjeT0iNDIiIHI9IjM5IiBmaWxsPSIjYzExIi8+CiAgPHBhdGggZD0iTTg1LDE5aC04djloNmgtNnYxMU04NSw0OGgtOHY5aDZoLTZ2MTEiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlPSIjRkZGIiBmaWxsPSJub25lIi8+CiAgPHBhdGggZD0iTTMsMTZoNjV2MTBoLTQwdjEwaDM4djEwaC0zOHYxMWg0MHYxMWgtNjV6IiBmaWxsPSIjMDAwIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj4KICA8cGF0aCBkPSJNNTAsMzBjOS0yMiA0Mi0yNCA0OCwwYzUsNDAtNDAsNDAtNDgsNjVjLTgtMjUtNTQtMjUtNDgtNjVjIDYtMjQgMzktMjIgNDgsMCB6IiBmaWxsPSIjRjAwIiBzdHJva2U9IiMwMDAiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj4KICA8cmVjdCBmaWxsPSIjRjgwIiB4PSIwIiB5PSIzIiBoZWlnaHQ9Ijk1IiB3aWR0aD0iOTUiIHJ4PSIxNSIvPgogIDxjaXJjbGUgY3g9IjE4IiBjeT0iODEiIHI9IjkiIGZpbGw9IiNGRkYiLz4KICA8cGF0aCBkPSJNNDgsODRzMC0zMy0zMy0zMyBNNzUsODRzMC02MC02MC02MCIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxNSIgc3Ryb2tlPSIjRkZGIiBmaWxsPSJub25lIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZpZXdCb3g9JzAgMCAxNjAgNjInIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zycgd2lkdGg9IjE2MCIgaGVpZ2h0PSI2MiI+CiAgPHBhdGggc3R5bGU9ImZpbGw6c2lsdmVyOyBzdHJva2U6YmxhY2siIGQ9J00xMywxOWMtNywwLTctOSwwLTlsODIsMmM2LDAsNi05LDEzLTlsNDIsMWMzLDAsMywzLDAsM2gtMzVjLTQsMC00LDMsMCwzaDM1YzMsMCwzLDMsMCwzaC0zOGMtMywwLTMsMywwLDNoMzhjMywwLDMsMywwLDNoLTM1Yy00LDAtNCwzLDAsM2gzNWMzLDAsMywzLDAsM2wtNDIsMWMtNywwLTctOS0xMy05ek0xNDUsNTBjNywwLDctOSwwLTlsLTg0LDJjLTYsMC03LTYtMTQtOWMtMTEtNi0zMSwxLTM2LDVjLTUsNC01LDksMCwxM2M1LDQsMjUsMTAsMzYsNWM3LTQsOS05LDE0LTl6JyAvPgo8L3N2Zz4K"

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHN0cm9rZT0iIzAwMCIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiPgogIDxwYXRoIGQ9Ik04LDgwcy01LDgsNSw5bDc4LDBzOSwwLDUtOWwtNDAtNzFzLTQtNi04LDB6IiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgLz4KICA8cGF0aCBkPSJNNTIsMTAgTDEwLDg1IEw5Myw4NXoiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZmlsbD0iI2ZjMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgPHBhdGggZD0iTTUyLDMybDAsMjYiIHN0cm9rZS13aWR0aD0iOSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICA8Y2lyY2xlIHI9IjYiIGN4PSI1MiIgY3k9IjczIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
  __webpack_require__(162)
}
var Component = __webpack_require__(57)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(278),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21dfbf25",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(57)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(277),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17d0d0e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 277:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedScale),
      expression: "selectedScale"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedScale = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("8")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "svg-canvas"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    attrs: {
      "id": "svgEmbed"
    }
  })])
}]}

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMode),
      expression: "selectedMode"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.modeList), function(item) {
    return _c('option', [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedImage),
      expression: "selectedImage"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedImage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.imageList), function(item) {
    return _c('option', [_vm._v(_vm._s(item))])
  })), _vm._v(" "), (_vm.selectedMode === 'd3') ? _c('div', [_c('d3-compare')], 1) : _vm._e(), _vm._v(" "), (_vm.selectedMode === 'pixi') ? _c('div', [_c('svg-compare')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ })

},[121]);


// WEBPACK FOOTER //
// static/js/app.45cc23ea5a7c4cc0def7.js